import DefaultMainPage from "../../pages/DefaultMainPage";
import Summary from "./Summary";
import UserStatistics from "./UserStatistics";
import Retentions from "./Retentions";
import ETCStatistics from "./ETCStatistics";
import PackageStatistics from "./PackageStatistics";

const analyticsMenuItems = [
    {path: "/statistics", component: <Summary/>, label: '개요'},
    {path: "/statistics/user_metric", component: <UserStatistics/>, label: '유저 통계'},
    {path: "/statistics/retention", component: <Retentions/>, label: '리텐션'},
    {path: "/statistics/analytics", component: <ETCStatistics/>, label: '매출 통계'},
    {path: "/statistics/package", component: <PackageStatistics/>, label: '패키지 통계'},
];

export const statisticsRoutes = {
    path: "/statistics",
    component: <DefaultMainPage buttons={analyticsMenuItems}/>,
    children: analyticsMenuItems
}